import _classCallCheck from "/builder/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/builder/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/builder/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "/builder/node_modules/@babel/runtime/helpers/esm/createSuper.js";
import { extension, PlainExtension, isInstanceOf } from '@remirror/core';
import { gapCursor, GapCursor } from '@remirror/pm/gapcursor';

var _dec, _class;
/**
 * Create a gap cursor plugin.
 *
 * @remarks
 *
 * When enabled, this will capture clicks near and arrow-key-motion past places
 * that don't have a normally selectable position nearby, and create a gap
 * cursor selection for them. The cursor is drawn as an element with class
 * `ProseMirror-gapcursor`.
 *
 * Make sure to import the styles as shown below.
 *
 * ```ts
 * import '@remirror/styles/extension-gap-cursor.css';
 * ```
 */


var GapCursorExtension = (_dec = extension({}), _dec(_class = /*#__PURE__*/function (_PlainExtension) {
  _inherits(GapCursorExtension, _PlainExtension);

  var _super = _createSuper(GapCursorExtension);

  function GapCursorExtension() {
    _classCallCheck(this, GapCursorExtension);

    return _super.apply(this, arguments);
  }

  _createClass(GapCursorExtension, [{
    key: "name",
    get: function get() {
      return 'gapCursor';
    }
  }, {
    key: "createExternalPlugins",
    value: function createExternalPlugins() {
      return [gapCursor()];
    }
  }]);

  return GapCursorExtension;
}(PlainExtension)) || _class);
/**
 * Predicate checking whether the selection is a GapCursor
 *
 * @param value - the value to check
 */

var isGapCursorSelection = isInstanceOf(GapCursor);
export { GapCursorExtension, isGapCursorSelection };